import * as React from 'react';
import FormControllerContext from '../form/FormControllerContext';

export default function useFormController() {
  return React.useContext(FormControllerContext);
}